import { render } from "./TripleCheckbox.vue?vue&type=template&id=820faf3c"
import script from "./TripleCheckbox.vue?vue&type=script&lang=js"
export * from "./TripleCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__